// @core/api/endpoints/authn/get_user_info.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserInfoResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get user information (OIDC UserInfo endpoint)
 * Returns OIDC standard claims about the authenticated user based on the granted scopes. Implements the OpenID Connect UserInfo endpoint specification.
 */
export async function GetUserInfo(
  params?: {
  },
  options?: RequestOptions
): Promise<GetUserInfoResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/userinfo`;
  const requestOptions = options;
  return client.get<GetUserInfoResponse>(requestPath, { ...requestOptions, params });
}
